import { jsx as m, jsxs as o } from "react/jsx-runtime";
import * as l from "react";
import { c as i } from "../clsx-OuTLNxxd.js";
import '../Stats.css';const d = "_stats_1n9bu_32", I = "_statsItem_1n9bu_41", _ = "_statsItemTitle_1n9bu_60", u = "_statsItemValue_1n9bu_73", s = {
  stats: d,
  statsItem: I,
  statsItemTitle: _,
  statsItemValue: u
}, f = l.forwardRef(({ className: t, ...a }, e) => /* @__PURE__ */ m("div", { className: i(s.stats, t), ref: e, ...a })), p = l.forwardRef(({ "aria-label": t, className: a, title: e, value: r, ...c }, n) => /* @__PURE__ */ o(
  "div",
  {
    className: i(s.statsItem, a),
    ref: n,
    ...c,
    "aria-label": t,
    "data-testid": "stats-item",
    children: [
      /* @__PURE__ */ m("p", { "aria-hidden": !!t, className: s.statsItemValue, children: r }),
      /* @__PURE__ */ m("p", { "aria-hidden": !!t, className: s.statsItemTitle, children: e })
    ]
  }
));
f.displayName = "Stats";
p.displayName = "StatsItem";
export {
  f as Stats,
  p as StatsItem
};
